import { render, staticRenderFns } from "./MuseumServicesPage.vue?vue&type=template&id=3acc29cc&scoped=true&"
import script from "./MuseumServicesPage.vue?vue&type=script&lang=js&"
export * from "./MuseumServicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc29cc",
  null
  
)

export default component.exports